import { delay } from "./delay";

export async function waitUntil(verifierFunc: () => Promise<boolean>|boolean, interval: number = 100, timeout: number = Infinity) {
    const startTime = Date.now();
    while (Date.now() - startTime <= timeout) {
        if (await verifierFunc()) return true;
        else await delay(interval);
    }
    return false;
}